module.exports = __webpack_public_path__ + "static/media/message.abf40415.svg";